/**
 * 聊天
 * Create by liaokai on 2020-05-23 18:08:47
 */
import * as React from 'react';
import {Component} from "react";
import {LiveChatList} from "./component/table";

interface IProps{

}

interface IState{

}

export class LiveChatView extends Component<IProps,IState>{
    readonly state : IState = {

    };
    render() {
        let {} = this.props;
        let {} = this.state;
        return (
            <div>
                <LiveChatList>

                </LiveChatList>
            </div>
        );
    }
}
